import { render, staticRenderFns } from "./data-access-standard-desc.vue?vue&type=template&id=2b590e6e&scoped=true&"
import script from "./data-access-standard-desc.vue?vue&type=script&lang=js&"
export * from "./data-access-standard-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b590e6e",
  null
  
)

export default component.exports